
// @ is an alias to /src
import { defineComponent } from 'vue';
import commonApi from '@/api/common';
import { message as $message } from 'ant-design-vue';
// import environment from '@/untils/environment';

export default defineComponent({
  name: 'Login',
  components: {
  },
  data() {
    return {
      loginState: 'login',
      isPassWord: false,
      mobile: '',
      validCode: '',
      parentInviteCode: '',
      password: '',
      passwordAgain: '',
      state: '',
    };
  },
  setup() {
    const error = (str: string) => {
      $message.error(str);
    };
    const success = (str: string) => {
      $message.success(str);
    };
    return {
      error,
      success,
    };
  },
  mounted() {
    console.log(this.$route);
    this.mobile = this.$route.query.mobile as string;
  },
  methods: {
    sendResetCode() {
      interface Data{
        data: TString;
        success: boolean;
        message: string;
      }
      if (!this.mobile) {
        this.error('请输入手机号码');
        return;
      }
      commonApi.sendResetCode({ mobile: this.mobile })
        .then(async ({ data, success, message }: Data) => {
          if (success) {
            console.log(data);
          } else {
            this.error(message);
          // this.$message.error(message);
          }
        });
    },
    nextStep() {
      if (!this.mobile) {
        this.error('请输入手机号码');
        return;
      }
      if (!this.validCode) {
        this.error('请输入验证码');
        return;
      }
      // 校验验证码
      interface Data{
        data: TString;
        success: boolean;
        message: string;
      }
      const params = {
        mobile: this.mobile,
        validCode: this.validCode,
      };
      // 确认新密码
      commonApi.checkResetCode(params)
        .then(async ({ data, success, message }: Data) => {
          if (success) {
            console.log(data);
            this.state = 'resetPassword';
          } else {
            this.error(message);
          }
        });
    },
    modifyPassword() {
      if (!this.password) {
        this.error('请输入新密码');
        return;
      }
      if (!this.passwordAgain) {
        this.error('请再次输入新密码');
        return;
      }
      if (this.password !== this.passwordAgain) {
        this.error('两次密码输入不一致，请重新输入');
        return;
      }
      console.log(123);
      const params = {
        mobile: this.mobile,
        password: this.password,
        confirmPassword: this.passwordAgain,
        validCode: this.validCode,
      };
      interface Data{
        data: TString;
        success: boolean;
        message: string;
      }
      // 确认新密码
      commonApi.modifyShopPassword(params)
        .then(async ({ data, success, message }: Data) => {
          if (success) {
            console.log(data);
            this.success('修改成功');
            this.$router.push('/login');
          } else {
            this.error(message);
          }
        });
    },
  },
});
